module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.productsSold.length > 0) ? _c('div', [_c('p', [_vm._v("\n            Out of " + _vm._s(_vm.products.length) + " products, " + _vm._s(_vm.productsSold.length) + " have been purchased at least once and\n            " + _vm._s(_vm.products.length - _vm.productsSold.length) + " products have never been purchased once.\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "button is-primary pull-right",
    attrs: {
      "href": '/api/reports/products?company=' + _vm.reportCompany
    }
  }, [_vm._v("Download in Excel")]), _vm._v(" "), _c('data-table', {
    attrs: {
      "data-set": _vm.productsSold,
      "page-length": 50,
      "columns": [{
          name: 'SKU',
          prop: 'sku',
          type: 'text'
        },
        {
          name: 'Pack Count',
          prop: 'sold',
          type: 'number'
        },
        {
          name: 'Shipping',
          prop: 'shipping',
          type: 'number'
        },
        {
          name: 'Subtotal',
          prop: 'subtotal',
          type: 'number'
        },
        {
          name: 'Total',
          prop: 'total',
          type: 'number'
        } ]
    },
    scopedSlots: _vm._u([{
      key: "column_Shipping",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.shipping)) + "\n            ")]
      }
    }, {
      key: "column_Subtotal",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.subtotal)) + "\n            ")]
      }
    }, {
      key: "column_Total",
      fn: function(props) {
        return [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.total)) + "\n            ")]
      }
    }], null, false, 3951210753)
  })], 1) : _c('div', [_vm._v("\n        0 results to show for this company and time period\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2cb80d19"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/reports/SalesByPack.vue
// module id = 518
// module chunks = 0